import _ from 'lodash';
import { connect } from 'react-redux';
import { search, add, update, remove } from '../../modules/reports/gasBuddyIgnoredStation';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state) => {
	/** @namespace state.lists.gasBuddyIgnoredStationIds **/
	/** @namespace state.maps.gasBuddyIgnoredStation **/
	let gasBuddyIgnoredStations;
	if (state.lists.gasBuddyIgnoredStationIds) {
		gasBuddyIgnoredStations = _.map(
			state.lists.gasBuddyIgnoredStationIds,
			(id) => state.maps.gasBuddyIgnoredStation[id]
		);
	}
	return {
		gasBuddyIgnoredStations,
		userMap: state.maps.user,
		stationMap: state.maps.station,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			gasBuddyIgnoredStationAdd: add,
			gasBuddyIgnoredStationSearch: search,
			gasBuddyIgnoredStationUpdate: update,
			gasBuddyIgnoredStationRemove: remove,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
